<script>
    let fieldSequence = 0

    export default {
        name: "FieldMixin",
        inject: {
            vcform: { from: "vcform" },
        },

        props: {
            value: [String, Number, Boolean, Date, Object, Array],
            id: {
                type: String,
                default: () => `field-${fieldSequence++}`,
            },
            label: {
                type: String,
                required: false,
            },
            validations: Object,
            required: {
                type: Boolean,
            },
            disabled: {
                type: Boolean,
            },
        },

        data() {
            return {
                valid: true,
                dirty: false,
                errors: {},
            }
        },

        computed: {
            fieldModel() {
                return {
                    label: this.label,
                    valid: this.valid,
                    dirty: this.dirty,
                    errors: this.errors,
                    invalid: this.invalid,
                    required: this.required,
                    disabled: this.disabled,
                }
            },

            invalid() {
                return !this.valid
            },

            errorMessages() {
                if (!this.invalid || !this.fieldModel || !this.fieldModel.errors) {
                    return []
                }

                const errorMessages = []

                for (const key of Object.keys(this.fieldModel.errors)) {
                    // if (key === "required") {
                    //     continue
                    // }

                    let error = this.fieldModel.errors[key]

                    if (!error) {
                        continue
                    }

                    errorMessages.push(this.vcform.errorMessage(this, error))
                }

                if (errorMessages.length) {
                    return errorMessages
                }

                if (this.vcform.defaultErrorMessage) {
                    return [this.vcform.defaultErrorMessage]
                }

                return []
            },
        },

        watch: {
            fieldModel() {
                if (this.group) {
                    this.group.updateInput(this)
                }

                if (this.vcform) {
                    this.vcform.updateInput(this)
                }

                this.$emit("field-model-change", this)
            },
        },

        created() {
            if (this.vcform) {
                this.vcform.registerInput(this)
            }
        },

        destroyed() {
            if (this.vcform) {
                this.vcform.deregisterInput(this)
            }
        },

        methods: {
            addValidationSource(source) {
                if (!this.validationSources) {
                    this.validationSources = []
                }

                this.validationSources.push(source)
            },

            removeValidationSource(source) {
                if (!this.validationSources) {
                    return
                }

                let index = this.validationSources.indexOf(source)

                if (index < 0) {
                    return
                }

                this.validationSources.splice(index, 1)
            },

            applyValidations(target) {
                this.applyRequiredValidator(target)
                if (this.validations) {
                    for (const key of Object.keys(this.validations)) {
                        this.applyValidator(target, key, this.validations[key])
                    }
                }

                if (this.validationSources != null) {
                    for (const source of this.validationSources) {
                        source(target, this)
                    }
                }
            },

            applyRequiredValidator(target) {
                this.applyValidator(target, "required", this.required)
            },

            applyValidator(target, validatorId, validator) {
                this.vcform.applyValidator(target, this, validatorId, validator)
            },

            getRemoteValidator() {
                return this.vcform.remoteValidator
            },

            setValidity(valid, errors) {
                this.valid = valid
                this.errors = errors
            },

            focus() {
                this.$refs.field.$el.focus()
            },

            scrollIntoView(opts) {
                this.$refs.field.$el.scrollIntoView(opts || {
                    block: "center",
                })
            },

            reset() {
                this.dirty = false
            },

            touch() {
                this.dirty = true
            },

            validate() {
                this.$emit("validate")
            },
        },
    }
</script>
